import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CredentialsService } from '../authentication/credentials.service';
import { UserRoles } from '../shared/models/user.interface'


@Component({
  selector: 'home-root',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private credentialService: CredentialsService
    //  private routeSubscription: Subscription

  ) {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    }
  }
  ngOnInit(): void {
    let roleId = UserRoles;
    const currentUser = localStorage.getItem("currentUser") || sessionStorage.getItem("currentUser") ;
    if( currentUser!=null){
      const currentRole = JSON.parse(currentUser).userRoles;
      let adminRole = currentRole.filter(u=> u.roleId == roleId['ADMIN']);
      let officerRole = currentRole.filter(u=> u.roleId == roleId['OFFICER']);
      let staffRole = currentRole.filter(u=> u.roleId == roleId['STAFF']);
      if((adminRole.length && adminRole[0].roleId == roleId.ADMIN)){
        this.router.navigate(['/admin'], { replaceUrl: true });
      }
      if((adminRole.length && adminRole[0].roleId == roleId.ADMIN) && (staffRole.length && staffRole[0].roleId == roleId.STAFF)){
        this.router.navigate(['/admin'], { replaceUrl: true });
      }
      if((adminRole.length && adminRole[0].roleId == roleId.ADMIN) && (officerRole.length && officerRole[0].roleId == roleId.OFFICER)){
        this.router.navigate(['/admin'], { replaceUrl: true });
      }
      if((adminRole.length && adminRole[0].roleId == roleId.ADMIN) && (officerRole.length && officerRole[0].roleId == roleId.OFFICER)){
        this.router.navigate(['/admin'], { replaceUrl: true });
      }
      if(staffRole.length && staffRole[0].roleId == roleId.STAFF){
        this.router.navigate(['/staff'], { replaceUrl: true }); 
      }
      if(officerRole.length && officerRole[0].roleId == roleId.OFFICER && adminRole.length==0){
        this.router.navigate(['/officer'], { replaceUrl: true });
      }
      if(staffRole.length && staffRole[0].roleId == roleId.STAFF && adminRole.length==0){
        this.router.navigate(['/staff'], { replaceUrl: true }); 
      }
    }else{
      this.router.navigate(['/sign-in'], { replaceUrl: true }); 
    }


    if (this.router.url) {
   console.log();
    }
  }
  // navigation links
  gotoOfficer() {
    this.router.navigate(['/login', { isOfficer: UserRoles.OFFICER }], { replaceUrl: true })
    // this.isEnable = true;
  }
  gotoAdmin() {
    console.log('here')
    this.router.navigate(['/login', { isAdmin: UserRoles.ADMIN }], { replaceUrl: true })
    // this.isEnable = true;
  }
  gotoVillageStaff() {
    const isVillageStaff = true;
    this.router.navigate(['/login', { isVillageStaff: UserRoles.STAFF }], { replaceUrl: true });
    // this.isEnable = true;
  }

}
